import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-secondary-popup',
  standalone: true,
  imports: [ClickOutsideDirective, CommonModule],
  templateUrl: './secondary-popup.component.html',
  styleUrl: './secondary-popup.component.scss',
})
export class SecondaryPopupComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() secondaryActionName = 'Cancel';
  @Input() primaryActionName = 'Submit';
  @Input() isActionButtonsAvailable = true;
  @Input() hideSecondaryButton = false;
  @Input() closeOnOutsideClick = true;

  @Output() popupClosed = new EventEmitter();
  @Output() primaryAction = new EventEmitter();
  @Output() secondaryAction = new EventEmitter();

  ngOnInit(): void {
    // Prevent body scrolling when popup is open
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    // Restore body scrolling when popup is closed
    document.body.style.overflow = '';
  }

  closePopup(isClickedOutside: boolean): void {
    if (isClickedOutside && !this.closeOnOutsideClick) {
      return;
    }
    this.popupClosed.emit(isClickedOutside);
  }

  onPrimaryAction(): void {
    this.primaryAction.emit();
  }

  onSecondaryAction(): void {
    this.secondaryAction.emit();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    this.closePopup(false);
  }
}
